import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

export interface MediaStore {
  media: Record<string, AudioBuffer | undefined>
  addMedia: (id: string, audioBuffer?: AudioBuffer) => void
}

const useMediaStore = create(
  subscribeWithSelector<MediaStore>((set) => ({
    media: {},
    addMedia: (id: string, audioBuffer?: AudioBuffer) => {
      set((state) => ({
        media: { ...state.media, [id]: audioBuffer },
      }))
    },
  }))
)

export default useMediaStore
